module.exports = __webpack_public_path__ + "img/XAF.dbdecb38.svg";